<template>
  <div id="route">
    <v-container>
      <v-card flat>
        <v-card-title>
          <v-flex xs12>
              <v-btn icon @click="setStep(1)">
                <v-icon>arrow_back_ios</v-icon>
              </v-btn>
            </v-flex>
          <v-layout row wrap>
            <v-flex xs1>
              {{ selectedRoute.id }}
            </v-flex>
            <v-flex xs7>
              <h2>{{ selectedRoute.description }}</h2>
            </v-flex>
            <v-flex x4>
              <v-btn color="success" v-if="needsComprobation" @click="createComprobation" >Captura</v-btn>
              <v-btn color="success" v-if="!needsComprobation" @click="closeRoute" >Cerrar Ruta</v-btn>
            </v-flex>
            <v-flex xs12>
              <h4>{{ selectedRoute.created_on | formatDate }}</h4>
            </v-flex>
            <v-flex xs12>
              <h4>Agente: {{ selectedRoute.name }}</h4>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <!--
                  Detalle de la captura de ruta
                -->
              <!--
                  Listado de compras realizadas en la ruta
                -->
              <!--
                  Verificacion de la ruta
                -->
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>
<script>

import { getComprobation, createComprobation, closeRoute } from '../../services/route';
import _ from 'lodash';
import {LOAD_COMPROBATION } from '@/store/actions/purcharseOrder';

export default {
  props: {
    selectedRoute: {
     default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      needsComprobation: true,
      errorMessage: '',
      hasError: false,
    };
  },
  computed: {
    comprobation() {
      return this.$store.state.purcharseOrder.purcharseOrder;
    },
  },
  /**
   * If the route has a initialized capture(comprobation) we must load it in the
   * store
   */
  watch: {
    async selectedRoute(newVal, oldVal) {
      await this.$store.dispatch(LOAD_COMPROBATION, newVal.id);
      this.needsComprobation = this.$store.state.purcharseOrder.purcharseOrder.id ? false : true;
    },
  },
  methods: {
    setStep(step) {
      this.$emit('set-step', step);
    },
    async createComprobation() {
      if (this.selectedRoute) {
        const response =  await createComprobation(this.selectedRoute.id);
        await this.$store.dispatch(LOAD_COMPROBATION, response.data.route_id);
        this.needsComprobation = this.$store.state.purcharseOrder.purcharseOrder.id ? false : true;
      }
    },
    async closeRoute() {
      if (!_.isEmpty(this.selectedRoute)) {
        try {
          await closeRoute(this.selectedRoute.id);
          this.$emit('route-close');
        } catch (error) {
          this.errorMessage = error.message;
        }
      }
    },
  },
};
</script>